import Marquee from "react-fast-marquee";
import { Leaf } from "lucide-react";

const WORDS = [
  "Yielding",
  "Flow & Form",
  "Presence",
  "The Current",
  "Stillness",
  "Meaning",
  "Slow Water",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="bg-pawc-ink py-8 border-y border-pawc-teal/20 overflow-hidden"
    aria-hidden="true"
  >
    <Marquee speed={25} gradient={false} pauseOnHover>
      {WORDS.map((w) => (
        <span key={w} className="flex items-center">
          <span className="font-serif italic text-2xl md:text-3xl text-pawc-mist/80 px-8">
            {w}
          </span>
          <Leaf size={18} className="text-pawc-terra/70" strokeWidth={1.5} />
        </span>
      ))}
    </Marquee>
  </div>
);
